import { useQuery } from "@tanstack/react-query";
import { kolService, SortBy, SortOrder } from "../services/kol.service";
import { QUERY_KEYS } from "../config/queryKeys";

interface UseKolsParams {
  page: number;
  limit: number;
  sortBy?: SortBy;
  sortOrder?: SortOrder;
}

export const useKols = ({ page, limit, sortBy, sortOrder }: UseKolsParams) => {
  return useQuery({
    queryKey: [QUERY_KEYS.KOLS, page, sortBy, sortOrder],
    queryFn: () => kolService.getKols({ page, limit, sortBy, sortOrder }),
    refetchInterval: 1000 * 5,
  });
}; 